// HU-32a (MG-ILE-63) · tarea 32a-6. La entrada con la cuenta corporativa y sus estados.
//
// Spec `ui/MG-ILE-63.md`, «Entrada» y «Estados»: un solo botón, «Ingresar con mi cuenta», que
// lleva a Microsoft (MSAL `loginRedirect`); no hay campos de usuario ni contraseña porque los
// captura Microsoft. El usuario externo sigue el mismo botón (HU-32a-C11, D-S3-17) y la nota se
// lo dice. Mientras se valida el token con `GET /sesion` la pantalla dice «Entrando…»; si
// Microsoft o el servidor no responden, la frase de la especificación y «Reintentar», nunca el
// error crudo de MSAL ni el texto técnico del 401.
//
// La misma pantalla cubre la carga y el error de la entrada SIMULADA: tras elegir rol también
// se espera `GET /sesion`.
import { KeyRound, LogIn, RotateCcw } from 'lucide-react';
import { Alert, Button } from '../components/ui';
import { PantallaDeEntrada } from './LoginSimulado';

export type EstadoDeLaEntrada = 'entrada' | 'cargando' | 'error';

/** Textos fijados por la especificación (ui/MG-ILE-63.md). */
const NOTA_PARA_EXTERNOS = 'Si no tienes correo de ILENDER, ingresa con el correo al que llegó tu invitación.';
const TEXTO_DEL_ERROR = 'No se pudo iniciar sesión. Inténtalo de nuevo o avisa al administrador.';

export default function Entrada({ estado, simulada = false, onIngresar, onReintentar }: {
  estado: EstadoDeLaEntrada;
  /** Ambiente sin Entra: el pie no nombra la cuenta corporativa. */
  simulada?: boolean;
  onIngresar?: () => void;
  onReintentar: () => void;
}) {
  return (
    <PantallaDeEntrada tituloDeLaPestana="Entrar"
      pie={simulada ? undefined : 'Inicio de sesión con la cuenta corporativa (Microsoft Entra ID)'}>
      <h1 className="font-display text-pantalla font-semibold text-marca-profundo">Hola</h1>

      {estado === 'cargando' && (
        <p data-testid="sesion-cargando" role="status" className="text-body text-ink-soft mt-4">Entrando…</p>
      )}

      {estado === 'error' && (
        <div className="mt-5 space-y-3">
          <Alert tone="danger" data-testid="sesion-error">{TEXTO_DEL_ERROR}</Alert>
          <Button variant="secondary" icon={RotateCcw} onClick={onReintentar} data-testid="sesion-reintentar">
            Reintentar
          </Button>
        </div>
      )}

      {estado === 'entrada' && onIngresar && (
        <div className="mt-6 space-y-4">
          <Button size="lg" icon={LogIn} onClick={onIngresar} className="w-full" data-testid="sesion-ingresar">
            Ingresar con mi cuenta
          </Button>
          <p data-testid="sesion-nota-externos" className="flex items-start gap-1.5 text-meta text-ink-soft">
            <KeyRound size={13} className="shrink-0 mt-0.5" aria-hidden="true" />
            <span>{NOTA_PARA_EXTERNOS}</span>
          </p>
        </div>
      )}
    </PantallaDeEntrada>
  );
}
